export default __webpack_public_path__ + "static/media/pancakeswap-cake-logo 1.fb9f396f.svg";